import RichTextDisplay from "@components/RichTextDisplay/RichTextDisplay";

export interface RichTextFullWidthProps {
  content: any;
  contentTinyMce?: any;
  addBorder: boolean;
  capitaliseFirstLetter?: boolean;
  hideFromScreenReaders?: boolean;
  isWhiteBackground?: boolean;
}

const RichTextFullWidth = (props: RichTextFullWidthProps) => {
  const {
    content,
    addBorder,
    capitaliseFirstLetter,
    contentTinyMce,
    isWhiteBackground,
  } = props;
  const contentBlock = (
    <div className="wrapper">
      <RichTextDisplay
        hideFromScreenReaders={props.hideFromScreenReaders}
        richText={content}
        tinyMceRichText={contentTinyMce}
        capitaliseFirstLetter={capitaliseFirstLetter}
        addBorder={addBorder}
        richTextStyles
      />
    </div>
  );

  if (isWhiteBackground) {
    return <div className="outer-wrap white">{contentBlock}</div>;
  }

  return contentBlock;
};

export default RichTextFullWidth;
